import { render, staticRenderFns } from "./ifmDesc.vue?vue&type=template&id=e305b1de&scoped=true"
import script from "./ifmDesc.vue?vue&type=script&lang=js"
export * from "./ifmDesc.vue?vue&type=script&lang=js"
import style0 from "./ifmDesc.vue?vue&type=style&index=0&id=e305b1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e305b1de",
  null
  
)

export default component.exports